// extracted by mini-css-extract-plugin
export default {"avaliacoes":"Avaliacoes_avaliacoes__cj3w1","container":"Avaliacoes_container__RGq8U","title":"Avaliacoes_title__Yo2Vo","avaliacoesWidget":"Avaliacoes_avaliacoesWidget__0i+4G"};